import { createAction, props } from '@ngrx/store';

export const selectFaqCategory = createAction(
  '[Account] SELECT_FAQ_CATEGORY',
  props<{ category: string }>(),
);

export const toggleAccordionItem = createAction(
  '[Account] TOGGLE_ACCORDION_ITEM',
  props<{ id: number }>(),
);

export const resetAccordionState = createAction(
  '[Account] RESET_ACCORDION_STATE',
);
